// extracted by mini-css-extract-plugin
export default {"contentCard":"TournamentContentCard_contentCard__g2y0+","contentPage":"TournamentContentCard_contentPage__CPt-h"};